module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0113.jpg?v=0b5bb95b";